import axios from 'axios'
import { get } from 'lodash'

import { AxiosError, AxiosTimeoutError, AxiosNetworkError } from '../errors'

export const timeoutRetryRejectionInterceptor = err => {
  if (
    err &&
    err.code === 'ECONNABORTED' &&
    err.config &&
    !err.config.__isRetryRequest
  ) {
    err.config.__isRetryRequest = true
    return axios(err.config)
  }
  throw err
}

export const betterErrorsRejectionInterceptor = err => {
  if (!err) {
    return null
  }

  const url = get(err, 'config.url')
  const statusCode = get(err, 'response.status')
  const endpoint = url && url.split('?')[0]

  if (err.message === 'Network Error') {
    throw AxiosNetworkError({
      url,
      message: err.message
    })
  }

  if (err.code === 'ECONNABORTED' || [408, 504].includes(statusCode)) {
    throw AxiosTimeoutError({
      endpoint,
      url,
      statusCode,
      code: err.code
    })
  }

  throw AxiosError({
    endpoint,
    url,
    statusCode,
    statusText: get(err, 'response.statusText'),
    httpMethod: get(err, 'config.method'),
    responseData: get(err, 'response.data'),
    responseHeaders: get(err, 'response.headers')
  })
}



// WEBPACK FOOTER //
// ./common/utils/axios/interceptors.js